/**
 * @generated SignedSource<<7abb6d0492297cbd297df82cb00f1f49>>
 * @relayHash 8b2ff323e16a050df8c910831d14d9f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd8c40298af1538495d6b83bd20c8bf46e26d79782a96520355ab9d630b0f31a

import type { ConcreteRequest } from 'relay-runtime';
export type utils_twg_microsite_CurrentUser_Query$variables = Record<PropertyKey, never>;
export type utils_twg_microsite_CurrentUser_Query$data = {
  readonly me: {
    readonly user: {
      readonly accountId?: string;
      readonly email?: string | null | undefined;
      readonly extendedProfile?: {
        readonly jobTitle: string | null | undefined;
        readonly organization: string | null | undefined;
      } | null | undefined;
      readonly id?: string;
      readonly name?: string;
      readonly nickname?: string | null | undefined;
      readonly orgId?: string | null | undefined;
      readonly picture?: AGG$URL;
    } | null | undefined;
  };
};
export type utils_twg_microsite_CurrentUser_Query = {
  response: utils_twg_microsite_CurrentUser_Query$data;
  variables: utils_twg_microsite_CurrentUser_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "nickname"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
},
v5 = {
  "kind": "ScalarField",
  "name": "email"
},
v6 = {
  "kind": "ScalarField",
  "name": "orgId"
},
v7 = {
  "concreteType": "AtlassianAccountUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jobTitle"
    },
    {
      "kind": "ScalarField",
      "name": "organization"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "utils_twg_microsite_CurrentUser_Query",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "utils_twg_microsite_CurrentUser_Query",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "type": "AtlassianAccountUser"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cd8c40298af1538495d6b83bd20c8bf46e26d79782a96520355ab9d630b0f31a",
    "metadata": {},
    "name": "utils_twg_microsite_CurrentUser_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "379630b0ee02d3d9fb6005a35f4d0740";

export default node;
